import { useRouter } from "next/router";
import React, { ReactElement } from "react";

import {
  BookingFormElementProps,
  useBookingFormElement,
} from "shared/hooks/bookingFormElement";
import { isBookingFormPassportNumberField } from "shared/lib/bookingFormPassportSelector";

import BookingFormArea from "@components/BookingForm/BookingFormArea";

import BookingFormInput from "./BookingFormInput";
import BookingFormPassportSelect from "./BookingFormPassportSelect";
import BookingFormRadio from "./BookingFormRadio";
import BookingFormRadioMarketplace from "./BookingFormRadioMarketplace";
import BookingFormSelect from "./BookingFormSelect";

export default function BookingFormElement({
  bookingFormElement,
  alert,
}: BookingFormElementProps): ReactElement {
  const router = useRouter();
  const { refs } = router.query;

  const {
    label,
    name,
    value,
    options,
    required,
    type,
    format,
    onChange,
    isHiddenLabel,
    isError,
    errorType,
    errorMessageOptions,
    finalPrice,
    dateRange,
  } = useBookingFormElement({
    bookingFormElementName: bookingFormElement,
    refs,
    alternativeCurrency: router.query.currency,
  });

  const isMarketplace = name.includes("marketplace");
  const InputComponent = isBookingFormPassportNumberField(name)
    ? BookingFormPassportSelect
    : BookingFormInput;

  return (
    <div
      className={`${
        isHiddenLabel
          ? "form-textarea-container"
          : `form-text-input-container${isMarketplace ? "-radio-list" : ""}`
      } ${isError ? "booking-form-element-error" : ""}`}
      id={name}
    >
      {!isHiddenLabel && (
        <span className={`form-text-input-label${required ? " required" : ""}`}>
          {label}
        </span>
      )}
      {type === "input" && (
        <InputComponent
          value={value}
          onChange={onChange}
          format={format}
          isError={isError}
          isPasswordField={name === "UserPassword"}
          errorType={errorType}
          errorMessageOptions={errorMessageOptions}
          name={name}
          dateRange={dateRange}
        />
      )}
      {type === "select" && (
        <BookingFormSelect
          value={value}
          onChange={onChange}
          options={options}
          isError={isError}
          errorType={errorType}
          name={name}
          finalPrice={finalPrice}
        />
      )}
      {type === "radio" && isMarketplace && (
        <BookingFormRadioMarketplace
          value={value}
          onChange={onChange}
          options={options}
          alert={alert}
          isError={isError}
          errorType={errorType}
          name={name}
        />
      )}
      {type === "radio" && !isMarketplace && (
        <BookingFormRadio
          value={value}
          onChange={onChange}
          options={options}
          isError={isError}
          errorType={errorType}
          name={name}
        />
      )}
      {type === "area" && (
        <BookingFormArea
          label={label}
          value={value}
          onChange={onChange}
          name={name}
        />
      )}
    </div>
  );
}
